<mat-sidenav-container class="cur-container" autosize>
  <!-- Side Menu -->
  <mat-sidenav #sidenav mode="side" opened="true" class="sidenav">
    <app-menu></app-menu>
  </mat-sidenav>
  <!-- Main content -->
  <mat-sidenav-content>
    <!-- Header -->
    <app-header (sidenavToggle)="sidenav.toggle()"></app-header>
    <!-- contents -->
    <div class="cur-contents-container">
      <router-outlet></router-outlet>
    </div>
    <!-- Footer -->
    <app-footer></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>